var map = {
	"./forum/images/img01.webp": 674,
	"./forum/presentation/forum1280.webp": 1370,
	"./forum/thumbnail/img01.webp": 8172,
	"./museum/images/img01.webp": 2527,
	"./museum/images/img02.webp": 2899,
	"./museum/images/img03.webp": 3029,
	"./museum/images/img04.webp": 1780,
	"./museum/presentation/museum1280.webp": 5661,
	"./museum/thumbnail/img01.webp": 5403,
	"./museum/thumbnail/img02.webp": 1375,
	"./museum/thumbnail/img03.webp": 8779,
	"./museum/thumbnail/img04.webp": 4646,
	"./mwenbwa/images/img01.webp": 433,
	"./mwenbwa/presentation/mwenbwa1280.webp": 8583,
	"./mwenbwa/thumbnail/img01.webp": 9643,
	"./pomodoro/images/img01.webp": 7254,
	"./pomodoro/presentation/pomodoro1280.webp": 4471,
	"./pomodoro/thumbnail/img01.webp": 3236,
	"./portfolio/images/img01.webp": 9004,
	"./portfolio/presentation/portfolio1280.webp": 8628,
	"./portfolio/thumbnail/img01.webp": 7747,
	"./restaurant/images/img01.webp": 7294,
	"./restaurant/images/img02.webp": 2489,
	"./restaurant/images/img03.webp": 2715,
	"./restaurant/images/img04.webp": 9102,
	"./restaurant/images/img05.webp": 2367,
	"./restaurant/presentation/restaurant1280.webp": 7628,
	"./restaurant/thumbnail/img01.webp": 3685,
	"./restaurant/thumbnail/img02.webp": 2051,
	"./restaurant/thumbnail/img03.webp": 8437,
	"./restaurant/thumbnail/img04.webp": 5409,
	"./restaurant/thumbnail/img05.webp": 3061
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 504;